<template>
  <li class="row-content" :class="containerClass">
    <i class="fa fa-users row-content--side"></i>
    <span @click.stop class="row-content--main">
      <span v-if="isText" class="t-500">Research Group: </span>
      <router-link v-if="renderWithLinkTo"
        :to="{name: 'research_group.show', params: {id: researchGroup.slug_values[0]}}"
        v-line-clamp="lineClamp"
        @click.native.prevent="linkToResearchGroup($event, researchGroup)"
        v-html="getResearchGroupName(researchGroup)">
      </router-link>
      <span v-else v-line-clamp="lineClamp" v-html="getResearchGroupName(researchGroup)"></span>
    </span>
  </li>
</template>

<script>

export default {
  name: 'searchPartialResearchGroup',
  props: {
    researchGroup: {
      type: Object,
      required: true
    },
    highlights: {
      type: Object,
      required: true
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'research_group.name'
    },
    containerClass: {
      type: String,
      default: 'pr-3'
    },
    renderWithLinkTo: {
      type: Boolean,
      default: true
    },
    lineClamp: {
      type: Number,
      default: -1
    },
    isText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getResearchGroupName (researchGroup) {
      let researchGroupName = researchGroup.name
      if (this.highlights && this.highlights[this.highlightKey]) {
        for (let o of this.highlights[this.highlightKey]) if (researchGroupName === this.stripTags(o)) researchGroupName = o
        return researchGroupName
      }

      return researchGroupName
    },
    linkToResearchGroup (e, researchGroup) {
      if (e.ctrlKey || e.metaKey) {
        let route = this.$router.resolve({ name: 'research_group.show', params: { id: researchGroup.slug_values[0] } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: 'research_group.show', params: { id: researchGroup.slug_values[0] } })
      }
    }
  }
}
</script>
